import React from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
const comparisonTable = [{
  sit: 'Te duele el cuello al final del día',
  sin: 'Tomás ibuprofeno y seguís igual',
  con: 'La Ingeniería de Postura elimina el dolor en 72 horas ajustando la altura de la camilla'
}, {
  sit: 'Tardás 2 horas en cada set',
  sin: 'Atendés 4 clientas por día con agotamiento total',
  con: 'El Método de Compresión bajás a 1:15hs y podés atender 6 sin más cansancio'
}, {
  sit: 'Los vapores del adhesivo te molestan',
  sin: 'Seguís expuesta sin sistema de protección',
  con: 'El Protocolo de Blindaje Químico protege tus pulmones y tu carrera a largo plazo'
}, {
  sit: 'Tus ojos están rojos al final de la jornada',
  sin: 'Fatiga visual acumulada día tras día',
  con: 'El Sistema de Protección Visual elimina el enrojecimiento y previene daño progresivo'
}, {
  sit: 'No sabés si vas a poder trabajar 10 años más',
  sin: 'Miedo real a que el cuerpo te obligue a parar',
  con: 'La Rutina Recuperadora de 5 minutos extiende tu carrera profesional 15 años'
}, {
  sit: 'Tus muñecas se entumecen',
  sin: 'Riesgo real de Túnel Carpiano',
  con: 'El Protocolo de Estiramientos Pro previene la lesión más común de la profesión'
}];
const eliteFeatures = ['Módulo 1: Ingeniería de Postura — el sistema de los 90 grados', 'Módulo 2: Compresión de Tiempos — bajá 45 minutos por set', 'Módulo 3: Blindaje Químico y Visual', 'Módulo 4: El Protocolo Recuperador de 5 minutos', 'Checklist de Estación de Trabajo Ergonómica', 'Guía de Estiramientos Pro para pegar en tu cabina', 'Cronómetro de Tiempos para detectar fugas', 'Lista de Compras Inteligente de equipamiento'];
export function PricingSection() {
  return <section id="pricing" className="py-16 md:py-24 bg-[#F4EDE4]" data-id="element-66">
      <div className="max-w-6xl mx-auto px-4" data-id="element-67">
        {/* Urgency */}
        <div className="max-w-2xl mx-auto text-center mb-12 md:mb-16" data-id="element-68">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#5A2A3D]/10 text-[#5A2A3D] font-bold text-xs uppercase tracking-[0.2em] mb-8 border border-[#5A2A3D]/20" data-id="element-69">
            <span className="w-1.5 h-1.5 rounded-full bg-[#5A2A3D] animate-pulse" data-id="element-70" />
            Precio de lanzamiento — Cierra en:
          </div>

          <CountdownTimer data-id="element-71" />

          <p className="text-base md:text-lg text-[#5A4A4F] mt-8 mb-6 italic" data-id="element-72">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </p>

          <div className="max-w-md mx-auto bg-white border border-[#E8D5C4] rounded-xl p-4 shadow-sm" data-id="element-73">
            <div className="text-xs font-bold text-[#5A2A3D] flex items-center gap-2 mb-2 uppercase tracking-wider" data-id="element-74">
              <span className="w-1.5 h-1.5 rounded-full bg-[#5A2A3D] animate-pulse" data-id="element-75" />
              Cupos al precio de lanzamiento — Quedan pocos
            </div>
            <div className="w-full bg-[#FAF6F0] rounded-full h-3 overflow-hidden mb-1 border border-[#E8D5C4]" data-id="element-76">
              <div className="bg-gradient-to-r from-[#5A2A3D] to-[#B8956A] h-3 rounded-full" style={{
              width: '68%'
            }} data-id="element-77" />
            </div>
            <div className="text-xs text-[#B8956A] text-right font-medium" data-id="element-78">
              68% ya tomados
            </div>
          </div>
        </div>

        <h2 className="text-4xl md:text-6xl text-[#2D1A22] text-center mb-10 md:mb-16 leading-tight" data-id="element-79">
          Elegí tu <span className="italic" data-id="element-80">Kit</span>
        </h2>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto mb-20 md:mb-24" data-id="element-81">
          {/* Card 1 */}
          <div className="bg-white border border-[#E8D5C4] rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col shadow-md" data-id="element-82">
            <div className="text-xs tracking-[0.25em] text-[#B8956A] font-bold uppercase mb-3" data-id="element-83">
              Plan Esencial
            </div>
            <h3 className="text-2xl md:text-3xl text-[#2D1A22] mb-2 leading-tight" data-id="element-84">
              Kit Lashista <span className="italic" data-id="element-85">Tu Agenda Profesional</span>
              ™
            </h3>
            <p className="text-[#5A2A3D] font-medium mb-5 text-sm md:text-base italic" data-id="element-86">
              4 Tomos + 4 Bonos de Acción Inmediata
            </p>
            <div className="bg-[#FAF6F0] rounded-xl p-4 mb-6 border border-[#E8D5C4]" data-id="element-87">
              <span className="text-[#B8956A] text-[10px] block mb-1 uppercase tracking-wider font-bold" data-id="element-88">
                Ideal para:
              </span>
              <span className="text-[#2D1A22] font-medium text-sm" data-id="element-89">
                Lashistas que quieren eliminar cancelaciones, instalar políticas
                reales y construir una agenda que sus clientas respetan.
              </span>
            </div>
            <div className="mb-6" data-id="element-90">
              <div className="text-[#5A4A4F]/60 line-through text-lg" data-id="element-91">
                $58.000
              </div>
              <div className="flex items-baseline gap-2" data-id="element-92">
                <div className="text-5xl text-[#2D1A22]" style={{
                fontFamily: "'DM Serif Display', serif"
              }} data-id="element-93">
                  $15.990
                </div>
                <span className="text-sm text-[#B8956A] font-medium" data-id="element-94">ARS</span>
              </div>
            </div>
            <a href="https://www.nexorecursos.com/cart/52544691831060:1" target="_blank" rel="noopener noreferrer" className="w-full py-4 rounded-full bg-[#FAF6F0] hover:bg-[#E8D5C4] text-[#5A2A3D] font-bold text-sm md:text-base transition-colors mt-auto border border-[#E8D5C4] text-center block tracking-wider uppercase" data-id="element-95">
              → Quiero mi Kit ahora
            </a>
          </div>

          {/* Card 2 - Highlighted */}
          <div className="bg-gradient-to-b from-[#FAF6F0] to-white border-2 border-[#5A2A3D] rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col relative shadow-xl" style={{
          boxShadow: '0 0 60px -15px rgba(90,42,61,0.3)'
        }} data-id="element-96">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#B8956A] text-white font-bold px-5 py-1.5 rounded-full text-xs uppercase tracking-[0.25em] shadow-md" data-id="element-97">
              ⭐ Más Elegido
            </div>
            <div className="text-xs tracking-[0.25em] text-[#B8956A] font-bold uppercase mb-3" data-id="element-98">
              Plan Élite
            </div>
            <h3 className="text-2xl md:text-3xl text-[#2D1A22] mb-2 leading-tight" data-id="element-99">
              Kit + <span className="italic" data-id="element-100">Lashista de Élite</span>
            </h3>
            <p className="text-[#5A2A3D] font-medium mb-5 text-sm md:text-base italic" data-id="element-101">
              4 Tomos + 4 Bonos + Sistema Lashista de Élite
            </p>
            <div className="bg-[#5A2A3D]/5 border border-[#5A2A3D]/20 rounded-xl p-4 mb-6" data-id="element-102">
              <span className="text-[#5A2A3D] text-[10px] block mb-1 uppercase tracking-wider font-bold" data-id="element-103">
                Ideal para:
              </span>
              <span className="text-[#2D1A22] font-medium text-sm" data-id="element-104">
                Lashistas que quieren además proteger su cuerpo, duplicar su
                velocidad de aplicación y construir una carrera de 20 años sin
                lesiones ni colapso físico.
              </span>
            </div>
            <div className="mb-6" data-id="element-105">
              <div className="text-[#5A4A4F]/60 line-through text-lg" data-id="element-106">
                $80.990
              </div>
              <div className="flex items-baseline gap-2" data-id="element-107">
                <div className="text-5xl text-[#2D1A22]" style={{
                fontFamily: "'DM Serif Display', serif"
              }} data-id="element-108">
                  $22.990
                </div>
                <span className="text-sm text-[#B8956A] font-medium" data-id="element-109">ARS</span>
              </div>
            </div>
            <a href="https://www.nexorecursos.com/cart/52544692879636:1" target="_blank" rel="noopener noreferrer" className="animate-pulse-glow w-full py-4 rounded-full bg-[#5A2A3D] hover:bg-[#6B3D4F] text-white font-bold text-sm md:text-base transition-all active:scale-95 mt-auto text-center block shadow-lg tracking-wider uppercase" data-id="element-110">
              → Quiero el Kit + Élite
            </a>
          </div>
        </div>

        {/* Elite Comparison */}
        <div className="max-w-5xl mx-auto" data-id="element-111">
          <h3 className="text-3xl md:text-5xl text-[#2D1A22] text-center mb-10 md:mb-12 leading-tight" data-id="element-112">
            ¿Qué agrega{' '}
            <span className="italic text-[#5A2A3D]" data-id="element-113">Lashista de Élite</span>?
          </h3>

          <div className="bg-white border border-[#E8D5C4] rounded-2xl md:rounded-3xl overflow-hidden mb-10 md:mb-12 shadow-md" data-id="element-114">
            <div className="overflow-x-auto" data-id="element-115">
              <table className="w-full text-left min-w-[700px]" data-id="element-116">
                <thead data-id="element-117">
                  <tr className="bg-[#FAF6F0]" data-id="element-118">
                    <th className="p-4 md:p-6 text-[#2D1A22] font-bold text-xs uppercase tracking-wider border-b border-[#E8D5C4] w-1/3" data-id="element-119">
                      Tu situación
                    </th>
                    <th className="p-4 md:p-6 text-[#5A2A3D] font-bold text-xs uppercase tracking-wider border-b border-[#E8D5C4] w-1/3" data-id="element-120">
                      ❌ Sin Élite
                    </th>
                    <th className="p-4 md:p-6 text-[#B8956A] font-bold text-xs uppercase tracking-wider border-b border-[#E8D5C4] w-1/3" data-id="element-121">
                      ✓ Con Élite
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-122">
                  {comparisonTable.map((row, i) => <tr key={i} className="border-b border-[#E8D5C4] hover:bg-[#FAF6F0]/50 transition-colors" data-id="element-123">
                      <td className="p-4 md:p-6 text-[#2D1A22] font-medium text-sm" data-id="element-124">
                        {row.sit}
                      </td>
                      <td className="p-4 md:p-6 text-[#5A4A4F] text-sm" data-id="element-125">
                        {row.sin}
                      </td>
                      <td className="p-4 md:p-6 text-[#5A2A3D] font-medium text-sm" data-id="element-126">
                        {row.con}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white border border-[#E8D5C4] rounded-2xl md:rounded-3xl p-6 md:p-10" data-id="element-127">
            <h4 className="text-2xl md:text-3xl text-[#2D1A22] mb-6 md:mb-8 text-center" data-id="element-128">
              <span className="italic" data-id="element-129">Lashista de Élite</span> incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-130">
              {eliteFeatures.map((f, i) => <div key={i} className="flex items-start gap-3" data-id="element-131">
                  <span className="text-[#B8956A] mt-0.5 shrink-0" data-id="element-132">✓</span>
                  <span className="text-[#5A4A4F] font-medium text-sm md:text-base" data-id="element-133">
                    {f}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}